<template>
  <div>
    <label for="hetznerSshKeys" class="block text-sm/6 font-medium text-gray-900 dark:text-white">{{
      label
    }}</label>
    <div class="mt-2 text-sm">
      <p v-if="loading" class="text-gray-500 dark:text-gray-400">Fetching…</p>
      <p v-else-if="error" class="text-red-600 dark:text-red-400">
        {{ error }}
      </p>
      <div v-else>
        <p v-if="keys.length === 0" class="text-gray-600 dark:text-gray-300">
          {{ emptyMessage }}
        </p>
        <fieldset v-else class="space-y-2">
          <div class="space-y-1">
            <label v-for="k in keys" :key="k.id" class="flex items-center gap-2">
              <input
                id="hetznerSshKeys"
                v-model="selected"
                type="checkbox"
                class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 dark:border-white/10 dark:bg-white/5"
                :value="String(k.id)"
              />
              <span class="text-gray-800 dark:text-gray-200">{{ k.name }}</span>
            </label>
          </div>
          <p class="mt-2 text-sm text-gray-500 dark:text-gray-400" id="hetznerSshKeys-desc">
            {{ description }}
          </p>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { SshKeyDto } from '@/api/hetzner';

const props = withDefaults(
  defineProps<{
    modelValue: string[];
    keys: SshKeyDto[];
    loading: boolean;
    error?: string;
    label?: string;
    emptyMessage?: string;
    description?: string;
  }>(),
  {
    error: '',
    label: 'Hetzner SSH Keys',
    emptyMessage: 'No SSH keys found for this Hetzner token.',
    description: 'Selected keys will be added to the root account of your runner VM.',
  }
);

const emit = defineEmits<{ (e: 'update:modelValue', value: string[]): void }>();

const selected = computed({
  get: () => props.modelValue,
  set: (value: string[]) => emit('update:modelValue', value),
});
</script>
